function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlpineCheckboxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "alpine-checkbox-checked",
    d: "M28.444,0L3.556,0C1.583,0 0,1.6 0,3.556L0,28.444C0,30.4 1.583,32 3.556,32L28.444,32C30.417,32 32,30.4 32,28.444L32,3.556C32,1.6 30.417,0 28.444,0ZM12.445,24.888L3.556,15.999L6.062,13.493L12.445,19.857L25.938,6.364L28.444,8.888L12.445,24.887L12.445,24.888Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlpineCheckboxChecked);
export default __webpack_public_path__ + "static/media/alpine-checkbox-checked.c29bd1415a8a40fc7854120a4e4737a6.svg";
export { ForwardRef as ReactComponent };